import { render } from "./QRScannerPage.vue?vue&type=template&id=275efb24"
import script from "./QRScannerPage.vue?vue&type=script&lang=js"
export * from "./QRScannerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__